import { Mail_01 } from '@recruit-robin/robin-theme/web-icons';
import { Badge, Row } from 'components/ui/atoms';
import { InboxConversationPreview } from 'components/ui/organisms/CentralInbox/InboxConversationPreview/InboxConversationPreview';
import { routes } from 'config/routes';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCampaignNewRepliesQuery } from 'shared/legacy/hooks/useGetCampaignNewRepliesQuery';
import { useGetUnreadConversationsAmount } from 'shared/legacy/hooks/useGetUnreadConversationsAmount';
import { useInboxStore } from 'stores/inbox/inbox.store';
import { useStyles } from './NewMessageReplies.styles';

export const NewMessageReplies = () => {
  useGetCampaignNewRepliesQuery();
  const isTeamViewEnabled = useInboxStore((s) => s.isTeamViewEnabled);
  const { data: unreadAmount = 0 } = useGetUnreadConversationsAmount(isTeamViewEnabled);
  const classes = useStyles();
  const [isPreviewOpened, setIsPreviewOpened] = useState(false);
  const pageContext = usePageContext();
  const navigate = useNavigate();

  const handleNotificationsClickEvent = useCallback(() => {
    navigate(routes.centralInbox);
  }, [navigate]);

  useEffect(() => {
    setIsPreviewOpened(false);
  }, [pageContext]);

  return (
    <div onMouseOver={() => setIsPreviewOpened(true)} onMouseLeave={() => setIsPreviewOpened(false)} css={classes.root}>
      <Row alignCenter onClick={handleNotificationsClickEvent} css={classes.content}>
        <Badge label={unreadAmount} showLabel={unreadAmount > 0} variant="highlight" alignment="top right">
          <Mail_01 color={(c) => c.neutral.variant[70]} size={18} />
        </Badge>
      </Row>
      {isPreviewOpened && pageContext !== PageContext.CentralInbox && (
        <div css={classes.floatingPanel}>
          <div css={classes.floatingArrow}></div>
          <InboxConversationPreview />
        </div>
      )}
    </div>
  );
};
